import { render, staticRenderFns } from "./QnaMain.vue?vue&type=template&id=d0b0d636&scoped=true&"
import script from "./QnaMain.vue?vue&type=script&lang=js&"
export * from "./QnaMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b0d636",
  null
  
)

export default component.exports